module.exports = __webpack_public_path__ + "img/database@2x.a4a7bdc5.jpg";